import { useTracker } from '@dpdgroupuk/react-event-tracker';
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTE_MANAGEMENT } from '../../../constants/analytics';
import modals from '../../../enums/modals';
import { updateSelectedStops } from '../../../store/reducers/ui/routeDetail/stopFilters';
import { getRouteDetail } from '../../../store/selectors/route';

import { wrapPromise } from '../../../utils/promise';
import { useModalContext } from '../../../components/ModalControlled/ModalProvider';

export default () => {
  const dispatch = useDispatch();
  const tracker = useTracker();

  const { getModalRef } = useModalContext();
  const routeDetail = useSelector(getRouteDetail);

  const openSelectMultipleStops = useCallback(async () => {
    tracker.logEvent(ROUTE_MANAGEMENT.CLICK_SELECT_MULTIPLE);
    const selectMultipleRef = getModalRef(modals.SELECT_MULTIPLE);
    const [result, canceled] = await wrapPromise(
      selectMultipleRef.current.showModal({
        routeStops: routeDetail.stop ?? [],
      })
    );

    if (canceled) {
      return;
    }

    const { from, to } = result;
    const [fromNormalized, toNormalized] = from <= to ? [from, to] : [to, from];

    dispatch(
      updateSelectedStops(
        routeDetail?.stop
          .slice(fromNormalized, toNormalized + 1)
          .map(({ stopId }) => stopId)
      )
    );
  }, [routeDetail, dispatch, tracker]);

  return {
    openSelectMultipleStops,
  };
};
